export default __webpack_public_path__ + "static/media/freedcamp.589345bf.svg";